module.exports = __webpack_public_path__ + "static/3dview-288484cf650107e63fcb88255fded9ee.gif";